// Payment System v3.0 PR 8 — Right-Size workflow React Query hooks (design
// spec §8.4). Preview is a pure mutation (no cache invalidation); execute
// invalidates the loan's detail surface so the LoanState bump to
// retired_right_size is observed immediately.

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { rightSizeApi } from "@/api/portfolioAdmin/rightSize";
import type {
  RightSizeExecuteRequest,
  RightSizePreviewRequest,
} from "@/types/rightSize";

export function usePreviewRightSize(loanId: string) {
  return useMutation({
    mutationFn: (body: RightSizePreviewRequest) =>
      rightSizeApi.preview(loanId, body),
  });
}

export function useExecuteRightSize(loanId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: RightSizeExecuteRequest) =>
      rightSizeApi.execute(loanId, body),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["loans", loanId] });
      qc.invalidateQueries({ queryKey: ["loans"] });
    },
  });
}
